module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/cta1-74eab94f0fca37f5ff62e7011dd89556.png";